export const blockIconsHardwareKeyboardBackspaceNew = (
	<span className='material-symbols-outlined'>keyboard_backspace</span>
);
